import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import '@fontsource/tilt-neon/400.css'
import '@fontsource/funnel-sans/400.css'
import '@fontsource/funnel-sans/500.css'
import '@fontsource/funnel-sans/600.css'
import '@fontsource/funnel-sans/700.css'
import '@fontsource/geist-mono/400.css'
import '@fontsource/urbanist/800.css'
import './styles/base.css'
import './styles/glass.css'
import './styles/sections.css'
import './styles/shared.css'
import './styles/type.css'
import App from './App'
import { AppErrorBoundary } from './components/ui/AppErrorBoundary'
import './styles/responsive.css'

// Log anything that slips past the error boundaries, so it never fails silently.
window.addEventListener('error', (e) => console.error('[mauj] Uncaught error:', e.error ?? e.message))
window.addEventListener('unhandledrejection', (e) => console.error('[mauj] Unhandled promise rejection:', e.reason))

const root = document.getElementById('root')
if (!root) throw new Error('Missing #root element in index.html')

createRoot(root).render(
  <StrictMode>
    <AppErrorBoundary>
      <App />
    </AppErrorBoundary>
  </StrictMode>,
)
